import 'css-chunk:src/feature/notification/PrintFailureToastNotification.module.scss';export default {
  "root": "PrintFailureToastNotification_root"
};